import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const useTranslationResilienceFlags = createFlagsHook<typeof import('./flags.json')>()
